import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginComponent } from '../public/login/login.component';
import { AuthService } from '../services/auth.service';
import { OrganizationService } from '../services/organization.service';
import { CreateUserComponent } from '../admin/createUser/createUser.component';
import { OrganizationSettingsComponent } from '../admin/organization-settings/organization-settings.component';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent implements OnInit {
  organization;

  constructor(private client: HttpClient, private authService: AuthService, private router: Router, private organizationService: OrganizationService) {}

  ngOnInit() {
    this.organizationService.getOrganization().then((organization) => {
      this.organization = organization;
    });
  }

  isAuthenticated() {
    return this.authService.isAuthenticated();
  }

  getAuthentication() {
    return this.authService.getAuthentication();
  }

  isCurrentPage(path: string) {
    const current = this.router.url.split('?')[0];
    return current === path;
  }

  loginClick() {
    this.router.navigate(['/login']);
  }

  createUserClick(){
    this.router.navigate(['/createUser']);
  }

  settingsClick(){
    this.router.navigate(['/organization-settings']);
  }

  expensesClick(){
    this.router.navigate(['/organization-expenses']);
  }

  reportsClick(){
    this.router.navigate(['/reports']);
  }

  archivedPropertiesClick(){
    this.router.navigate(['/archived-properties']);
  }


  logoutClick() {
    this.authService.logout();
  }
}
